module.exports = __webpack_public_path__ + "static/determined-collapsed-1-74e2fafd6c885946a6e3e90d957579ff.png";